export const NAVIGATION_LABELS = {
    DASHBOARD: {
        NAV_ITEM: "Dashboard"
    },
    GO_TO_PORTAL: "IDŹ NA PORTAL",
    MESSAGES: {
        NAV_ITEM: "Wiadomości"
    },
    NAV_SECTION: {
        DESKTOP: "NAWIGACJA"
    },
    PREFERENCES: {
        CTA: "Czego szukasz"
    },
    PROFILE_GREETING: {
        DESKTOP_PREFIX: "Cześć",
        SETTINGS_SUBTITLE: "Ustawienia"
    },
    PROFILE_MENU: {
        ACCOUNT_SETTINGS: "Ustawienia konta",
        LOGOUT: "Wyloguj"
    },
    SECTION: {
        DISMISSED: {
            BOTTOM_NAV: "Odrzucone",
            SIDEBAR: "Odrzucone"
        },
        FAVORITES: {
            BOTTOM_NAV: "Ulubione",
            SIDEBAR: "Ulubione"
        },
        INQUIRIES: {
            BOTTOM_NAV: "Zapytania",
            SIDEBAR: "Złożone zapytania"
        }
    },
    SECTION_GROUP: {
        DESKTOP: "Twoje oferty"
    }
} as const;
export const NAVIGATION_LABELS = {
    DASHBOARD: {
        NAV_ITEM: "Dashboard"
    },
    GO_TO_PORTAL: "IDŹ NA PORTAL",
    MESSAGES: {
        NAV_ITEM: "Wiadomości"
    },
    NAV_SECTION: {
        DESKTOP: "NAWIGACJA"
    },
    PREFERENCES: {
        CTA: "Czego szukasz"
    },
    PROFILE_GREETING: {
        DESKTOP_PREFIX: "Cześć",
        SETTINGS_SUBTITLE: "Ustawienia"
    },
    PROFILE_MENU: {
        ACCOUNT_SETTINGS: "Ustawienia konta",
        LOGOUT: "Wyloguj"
    },
    SECTION: {
        DISMISSED: {
            BOTTOM_NAV: "Odrzucone",
            SIDEBAR: "Odrzucone"
        },
        FAVORITES: {
            BOTTOM_NAV: "Ulubione",
            SIDEBAR: "Ulubione"
        },
        INQUIRIES: {
            BOTTOM_NAV: "Zapytania",
            SIDEBAR: "Złożone zapytania"
        }
    },
    SECTION_GROUP: {
        DESKTOP: "Twoje oferty"
    }
} as const;
